import React from "react";
import { TrendingUp } from "lucide-react";
import { CareerCard } from "./CareerCard";
import { scoreBarColor, scoreColor } from "@/lib/careerConfig";
import { cn } from "@/lib/utils";
import { translateFr as tfr } from "@/i18n";

const STATUS_LABELS = {
  accelerating: { label: tfr("En accélération"), cls: "text-success" },
  steady: { label: "Rythme stable", cls: "text-info" },
  slow: { label: tfr("À relancer"), cls: "text-warning" },
  insufficient: { label: tfr("Données insuffisantes"), cls: "text-muted-foreground" },
};

export function VelocityCard({ velocity }) {
  const meta = STATUS_LABELS[velocity.status] || STATUS_LABELS.insufficient;
  return (
    <CareerCard icon={TrendingUp} title="Career Velocity" subtitle={tfr("Rythme d'exécution du plan")} testid="velocity-card">
      <div className="flex items-baseline gap-3">
        <span className={cn("text-4xl font-bold tabular-nums", scoreColor(velocity.score))} data-testid="velocity-score">
          {velocity.score === null || velocity.score === undefined ? "—" : velocity.score}
        </span>
        {velocity.score !== null && velocity.score !== undefined && <span className="text-sm text-muted-foreground">/ 100</span>}
        <span className={cn("text-sm font-medium ml-auto", meta.cls)} data-testid="velocity-status">{meta.label}</span>
      </div>
      {velocity.factors?.length > 0 && (
        <ul className="mt-4 space-y-3">
          {velocity.factors.map((f) => (
            <li key={f.key} data-testid={`velocity-factor-${f.key}`}>
              <div className="flex items-center justify-between gap-2 mb-1">
                <span className="text-xs font-medium text-foreground/90">{f.label}</span>
                <span className="text-xs font-semibold tabular-nums text-muted-foreground">{f.impact}%</span>
              </div>
              <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
                <div className={cn("h-full rounded-full", scoreBarColor(f.impact))} style={{ width: `${f.impact}%` }} />
              </div>
            </li>
          ))}
        </ul>
      )}
      {(velocity.score === null || velocity.score === undefined) && (
        <p className="text-sm text-muted-foreground mt-2">{tfr("Ajoutez des jalons et objectifs pour mesurer le rythme d'exécution.")}</p>
      )}
      <p className="text-[11px] text-muted-foreground mt-4 pt-3 border-t border-border">
        {tfr("Indicateur interne de pilotage — calculé sur la progression des objectifs et jalons.")}
      </p>
    </CareerCard>
  );
}
